module.exports = __webpack_public_path__ + "img/no-data_chart.ac700a99.svg";